<template>
  <div class="box">
    <h1 class="title">
      “三秦好少年・红飘带 少年心”主题征文活动<br />作品上传平台
    </h1>
    <div class="login">
		<div class="guide-btn">
			<Guide></Guide>
		</div>
      <div class="sub">
        {{ welcomeWord }}
      </div>
      <!-- 登录类型切换tab -->
      <div class="login-tabs">
        <div
          class="login-tab"
          :class="{ active: loginType === 'school' }"
          @click="switchTab('school')"
        >学校登录</div>
        <div
          class="login-tab"
          :class="{ active: loginType === 'personal' }"
          @click="switchTab('personal')"
        >个人登录</div>
      </div>
      <div class="form">
        <div class="ipt">
          <input
            type="tel"
            class="tel"
            v-model="user.cellphone"
			maxlength="11"
            placeholder="请输入手机号"
          />
        </div>
        <div class="ipt">
          <input
            type="text"
            class="full captcha"
            v-model="captchaCode"
            maxlength="6"
            placeholder="请输入图形验证码"
          />
          <img
            class="captcha-img"
            :src="captchaImg"
            title="看不清？点击刷新"
            @click="refreshCaptcha"
          />
        </div>
        <div class="ipt">
          <input
            type="tel"
            class="full"
            v-model="user.code"
            placeholder="请输入验证码"
          /><button class="code" :disabled="codeSending" @click="sendSms">
            {{ codeMsg }}
          </button>
        </div>
        <div class="btn">
          <button @click="login">{{ loginBtnText }}</button>
        </div>
        <div class="infos">
          <label class="remember"
            ><input type="checkbox" v-model="user.remember" /><b></b
            >记住登录信息</label
          >
          <span class="tip">未注册的手机号验证后自动登录</span>
        </div>
      </div>
    </div>
	
   <div class="guidance">
	 <div class="logo">
	   <img src="@/assets/guidance.png" />
	 </div>
	 <div class="text">
	   <div><strong>主办单位：</strong>陕西省教育系统关心下一代工作委员会</div>
	   <div><strong>承办单位：</strong>重庆课堂内外文化发展有限公司</div>
	 </div>
	 <div class="douyin-qr">
	   <img src="@/assets/sqhsn-douyin.png" alt="抖音二维码" />
	   <!-- <p>抖音扫码免费观看<br />快速提升作文技巧</p> -->
	 </div>
   </div>

    <div class="copyright">
      <div class="flex align-center">
			<div class="copyright-item mr-5">
				重庆课堂内外文化发展有限公司版权所有
			</div>
			<div class="copyright-item mr-5 head-pointer" @click="pageUrl('https://beian.miit.gov.cn/#/Integrated/index')">渝ICP备12005747号</div>
			<div class="copyright-item head-pointer beian-icon" @click="pageUrl('https://beian.mps.gov.cn/#/query/webSearch?code=50019002504657')">渝公网安备50019002504657号</div>
		</div>
    </div>
  </div>
</template>

<script>
import Guide from '@/components/Guide.vue'
import { login, sendSms, getStatus, getCaptcha } from "@/api/user.js";
import { getToken, setToken } from "@/utils/auth";
export default {
  name: "login",
  components:{ Guide },
  data() {
    return {
      welcomeWord: "您好，欢迎登录！",
      getCode: "获取验证码",
      waitCode: "秒后重发",
      loginWord: "登录",
      codeSending: false,
      smsTimer: null,
      waitTimes: 90,
      captchaId: "", // 图形验证码 id
      captchaImg: "", // 图形验证码图片（base64 Data URI）
      captchaCode: "", // 用户输入的图形验证码
      loginType: "personal", // 登录类型：personal-个人登录，school-学校登录
      user: {
        cellphone: "",
        code: "",
        role: 1, // 角色：1-个人，31-学校
        remember:
          window.localStorage.getItem("remember") == "true" ? true : false,
      },
    };
  },
  created() {
    // 页面加载时预取图形验证码
    this.refreshCaptcha();
    let token = getToken();
    if (token) {
      // 个人用户跳过 status 接口，直接进入个人作品主页
      const role = window.localStorage.getItem("role");
      if (role === "1") {
        this.$router.push("/my-works");
        return;
      }
      this.getStatus();
    }
  },
  computed: {
    codeMsg() {
      return this.codeSending ? this.waitTimes + this.waitCode : this.getCode;
    },
    // 根据登录类型显示不同的按钮文案
    loginBtnText() {
      return this.loginType === "school" ? "学校登录" : "个人登录";
    },
  },
  methods: {
    // 切换登录类型tab，同时更新role字段
    switchTab(type) {
      this.loginType = type;
      this.user.role = type === "school" ? 31 : 1;
    },
    login() {
      let data = this.user;
      if (this.user.cellphone) {
        if (this.verifyTel(this.user.cellphone)) {
          if (this.user.code) {
            login(data).then((d) => {
              let token = d.access_token;
              setToken(token, this.user.remember);
              // 存储登录角色，用于后续页面判断
              window.localStorage.setItem("role", d.role);
              // 个人用户直接进入个人作品主页，学校用户检查注册状态
              if (d.role == 1) {
                this.$router.push("/my-works");
              } else {
                this.getStatus();
              }
            });
          } else {
            this.$message.error("请填写验证码");
          }
        } else {
          this.$message.error("请填写正确的手机号码");
        }
      }
    },
    getStatus() {
      getStatus().then((d) => {
        let name = d.data.name?d.data.name:"";
        let type = d.data.type||"";
        if (name) {
          window.localStorage.setItem("name", name);
        } else {
          window.localStorage.removeItem("name");
        }
        if (type) {
          window.localStorage.setItem("type", type);
        } else {
          window.localStorage.removeItem("type");
        }
        window.localStorage.setItem("phone",d.data.phone)
        let status = d.data.status;
        let remark = d.data.remark;
        if (status == -1) {
          this.$router.push("/reg");
        } else if (status == 1) {
          this.$router.push("/main");
        } else {
          this.$router.push({ path: "/info", query: { status,remark } });
        }
      });
    },
    // 刷新图形验证码
    refreshCaptcha() {
      getCaptcha()
        .then((d) => {
          this.captchaId = d.data.captcha_id;
          this.captchaImg = d.data.image;
          this.captchaCode = "";
        })
        .catch(() => {});
    },
    // 发送短信验证码（需先通过图形验证码防护）
    sendSms() {
      let { cellphone } = this.user;
      if (this.verifyTel(this.user.cellphone)) {
        if (!this.captchaCode) {
          this.$message.error("请输入图形验证码");
          return;
        }
        sendSms({
          cellphone,
          captcha_id: this.captchaId,
          captcha_code: this.captchaCode,
        })
          .then((d) => {
            this.$message.success("验证码已发送");
            this.countDown();
          })
          .catch((e) => {
            // 仅图形验证码校验失败（后端已一次性失效）时刷新并清空，其他错误（如限流）保留用户输入
            if (e && e.message && e.message.indexOf("图形验证码") !== -1) {
              this.refreshCaptcha();
            }
          });
      } else {
        this.$message.error("请填写正确的手机号码");
      }
    },
    verifyTel(tel) {
      let reg = /^(13[0-9]|14[01456879]|15[0-3,5-9]|16[2567]|17[0-8]|18[0-9]|19[0-3,5-9])\d{8}$/;
      let result = false;
      if (tel) {
        if (reg.test(tel)) {
          result = true;
        } else {
          result = false;
        }
      } else {
        result = false;
      }
      return result;
    },
    countDown() {
      clearInterval(this.smsTimer);
      this.codeSending = true;
      this.smsTimer = setInterval(() => {
        if (this.waitTimes > 0) {
          this.waitTimes--;
        } else {
          clearTimeout(this.smsTimer);
          this.codeSending = false;
          this.waitTimes = 90;
        }
      }, 1000);
    },

    pageUrl(url){
      window.open(url,'_brack')
      // window.location.href = url;
    }
  },
};
</script>
<style lang="scss" scoped>
$defaultRed: #bc463b;
$defaultRedHover: #f17a70;
$defaultBtnDis: #aaaaaa;
.box {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: url("~@/assets/main_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  z-index: 1;
  .title {
    display: block;
    margin: 92px 0 0 146px;
    font-size: 42px;
    font-weight: bold;
    color: #6e3621;
    line-height: 1.4;
    max-width: 1000px;
    text-shadow: 5px 5px 13px #b9af99;
  }
  .guide-btn{
	  text-align: right;
  }
  .login {
    padding: 50px;
    border-radius: 20px;
    margin: 62px 0 0 236px;
    width: 487px;
    height: auto;
    background: rgba(249, 235, 217, 0.7);
    .sub {
      margin-top: 30px;
      font-size: 26px;
      color: $defaultRed;
      &:after {
        content: "";
        display: block;
        margin-top: 17px;
        width: 71px;
        height: 2px;
        background-color: $defaultRed;
      }
    }
    .login-tabs {
      display: flex;
      margin-top: 30px;
      border-radius: 25px;
      overflow: hidden;
      .login-tab {
        flex: 1;
        height: 44px;
        line-height: 44px;
        text-align: center;
        font-size: 16px;
        color: #666;
        background-color: #f5f5f5;
        cursor: pointer;
        transition: all 0.3s;
        &.active {
          color: #fff;
          background-color: $defaultRed;
        }
        &:hover:not(.active) {
          color: $defaultRed;
        }
      }
    }
    .form {
      margin-top: 22px;
      .ipt {
        margin-top: 10px;
        display: flex;
        gap: 4px;
        input {
          display: block;
          padding: 0 15px;
          width: 100%;
          height: 50px;
          background-color: #fff;
          border: 0;
          font-size: 14px;
          outline: 0;
          &:focus {
            border: 1px solid $defaultRed;
            padding: 0 14px;
          }
        }
        button {
          width: 104px;
          height: 50px;
          line-height: 50px;
          text-align: center;
          font-size: 14px;
          color: #fff;
          flex-shrink: 0;
          border: 0;
          background-color: $defaultRed;
          cursor: pointer;
          outline: 0;
          &:hover {
            background-color: $defaultRedHover;
          }
          &:disabled {
            background-color: $defaultBtnDis;
            cursor: no-drop;
          }
        }
        .captcha-img {
          width: 180px;
          height: 50px;
          flex-shrink: 0;
          cursor: pointer;
          display: block;
        }
      }
      .btn {
        margin-top: 33px;
        button {
          display: block;
          width: 100%;
          height: 50px;
          background-color: $defaultRed;
          border-radius: 25px;
          text-align: center;
          color: #fff;
          font-size: 22px;
          cursor: pointer;
          &:hover {
            background-color: $defaultRedHover;
          }
        }
      }
      .infos {
        margin-top: 30px;
        font-size: 14px;
        color: #000;
        .remember {
          float: left;
          cursor: pointer;
          user-select: none;
          input {
            position: absolute;
            left: -300px;
            &:checked + b {
              background: url("../../assets/icon_check.png") no-repeat center
                center;
              background-color: $defaultRed;
              border: 0;
            }
          }
          b {
            display: block;
            float: left;
            margin-top: 3px;
            margin-right: 5px;
            width: 15px;
            height: 15px;
            border-radius: 50%;
            border: 2px solid $defaultBtnDis;
          }
        }
        .tip {
          float: right;
        }
      }
    }
  }
  .guidance {
    position: absolute;
    right: 100px;
    top: 93px;
    .logo {
      img {
        display: block;
      }
    }
    .text {
      margin-top: 20px;
      font-size: 18px;
      color: #6e3621;;
      line-height: 30px;
    }
    .douyin-qr {
      img {
        width: 185px;
        height: auto;
        bottom: 20px;
        right: 60px;
        position: fixed;
        z-index: 1;
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .box {
    .title {
      font-size: 40px;
      max-width: 800px;
    }
    .login {
      margin: 50px 0 0 140px;
      padding: 40px 40px 60px;
      width: 400px;
      border-radius: 10px;
      height: auto;
      background: rgba(249, 235, 217, 0.7);
      .sub {
        margin-top: 0;
      }
    }
    .guidance {
      right: 40px;
      top: 40px;
      .text {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
}
@media screen and (max-width: 1400px) {
  .box {
    .title {
      margin: 40px;
      font-size: 36px;
      max-width: 700px;
    }
    .login {
      margin: 40px 0 0 70px;
      padding: 40px 40px 60px;
      width: 400px;
      border-radius: 10px;
      height: auto;
      background: rgba(249, 235, 217, 0.7);
      .sub {
        margin-top: 0;
      }
    }
    .guidance {
      right: 30px;
      top: 30px;
      .text {
        font-size: 16px;
        line-height: 24px;
      }
    }
  }
}
@media screen and (max-width: 1100px) {
  .box {
    .title {
      margin: 40px;
      font-size: 30px;
      max-width: 600px;
    }
    .login {
      margin: 40px;
      padding: 20px 20px 40px;
      width: 400px;
      border-radius: 10px;
      height: auto;
      background: rgba(249, 235, 217, 0.7);
      .sub {
        margin-top: 0;
      }
    }
    .guidance {
      right: 40px;
      top: 20px;
      .text {
        font-size: 14px;
        line-height: 22px;
      }
    }
  }
}

.copyright {
  position: fixed;
  left: 0;
  bottom: 20px;
  width: 100%;
  background: rgba(0,0,0,.5);
  height: 32px;
  line-height: 32px;
  font-size: 12px;
  color: #fff;
  text-align: center;
  .flex {
    display: flex;
    margin: 0 auto;
    justify-content: center;
  }
  .mr-5 {
    margin-right: 5px;

  }
  .head-pointer{
    cursor: pointer;
  }
  .beian-icon {
    background: url("../../assets/benan-icon.png") no-repeat left center;
    padding-left: 20px;
    background-size: 16px auto;
  }

}
</style>
